const TableOfContents = {
  selectors: {
    anchorList: '.text-block h3',
    tocWrapper: '.static-wrapper__sidebar',
    tocContainer: 'ul',
    tocLink: 'static-inner-nav__list-item',
    tocLinkIsSelected: 'is-selected',
    staticPageWrapper: '.static-wrapper__main',
    staticPageIsCentered: 'is-centered',
  },

  generate() {
    this.isFirstLink = true;
    this.table = document.querySelector(this.selectors.tocWrapper);
    this.tableItemContainer = this.table.querySelector(
      this.selectors.tocContainer,
    );
    this.anchorList = document.querySelectorAll(this.selectors.anchorList);

    if (this.anchorList.length === 0 || this.tableItemContainer === null) {
      return this;
    }

    for (let index = 0; this.anchorList.length > index; index++) {
      this._addLinkForAnchor(index);
    }

    this.table.style.removeProperty('display');
    const staticPageWrapper = document.querySelector(
      this.selectors.staticPageWrapper,
    );
    if (staticPageWrapper !== null) {
      staticPageWrapper.classList.remove(this.selectors.staticPageIsCentered);
    }
  },

  _addLinkForAnchor(anchorIndex) {
    const anchor = this.anchorList[anchorIndex];
    const id = `toc-${anchorIndex}`;
    anchor.setAttribute('id', id);

    const link = document.createElement('a');
    link.setAttribute('href', `#${id}`);
    link.className = this.selectors.tocLink;
    link.innerText = anchor.innerText;
    link.addEventListener('click', this._scrollToSection);

    if (this.isFirstLink) {
      this.isFirstLink = false;
      link.classList.add(this.selectors.tocLinkIsSelected);
    }

    const listItem = document.createElement('li');
    listItem.append(link);
    this.tableItemContainer.append(listItem);
  },

  _scrollToSection(event) {
    event.preventDefault();

    const anchor = event.target;
    const targetId = anchor.getAttribute('href');
    const anchorTarget = document.querySelector(targetId);

    if (anchorTarget === null) {
      return;
    }

    const anchorList = document.querySelectorAll(
      `${TableOfContents.selectors.tocWrapper} a`,
    );
    for (const anchorChild of anchorList) {
      anchorChild.classList.remove('is-selected');
    }
    anchor.classList.add('is-selected');

    if ('scrollBehavior' in document.documentElement.style) {
      anchorTarget.scrollIntoView({ behavior: 'smooth' });
      return;
    }
    anchorTarget.scrollIntoView();
  },
};

document.addEventListener('DOMContentLoaded', () => {
  TableOfContents.generate();
});
